import { Suspense } from 'react';
import { Outlet } from 'react-router';
import logo from '@/assets/logo.png';

const Header = () => {
  return (
    <header className="bg-zinc-800 h-14 flex items-center px-5">
      <h1>
        <img src={logo} alt="アニマルオフィス" className="h-10 w-auto" />
      </h1>
    </header>
  );
};

export const GuestLayout = () => {
  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <main className="flex-1 relative flex flex-col">
        <Suspense>
          <Outlet />
        </Suspense>
      </main>
    </div>
  );
};
